const exhibitsFinder = function (opts) {
  const guidGenerator = function () {
    var S4 = function () {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return (
      S4() +
      S4() +
      "-" +
      S4() +
      "-" +
      S4() +
      "-" +
      S4() +
      "-" +
      S4() +
      S4() +
      S4()
    );
  };

  function getBreakSectionRegex() {
    const regexTerms = [
      /^(article (\S*))(\s?[a-z][^\.]{,64}\.)?/,
      /^(exhibit (\S*))(\s?[a-z][^\.]{,64}\.)?/,
      /^(annex (\S*))(\s?[a-z][^\.]{,64}\.)?/,
      /^(schedule (\S*))(\s?[a-z][^\.]{,64}\.)?/,
    ];

    const regex = new RegExp(regexTerms.map((r) => r.source).join("|"), "gi");
    return regex;
  }

  function getSigPageRegex() {
    const regexTerms = [/(signature page (\S*))(\s?[a-z][^\.]{,64}\.)?/];

    const regex = new RegExp(regexTerms.map((r) => r.source).join("|"), "gi");
    return regex;
  }

  function getTitleRegex() {
    const regexTerms = [/(exhibit (\S*))([^\W]+)/];

    const regex = new RegExp(regexTerms.map((r) => r.source).join("|"), "gi");
    return regex;
  }

  function getWordRegex() {
    //const regexTerms = [/(exhibit (\S*))(\s?[a-z][^\.]{,64}\.)?/];
    const regexTerms = [/(exhibit (\S*))([^\W]+)/];

    const regex = new RegExp(regexTerms.map((r) => r.source).join("|"), "gi");
    return regex;
  }

  function getDefinedRegEx() {
    const regexTerms = [
      /^([\d.\t\s]*)?((exhibit (\S*))(\s?[a-z][^\.]{,64}\.)?)[^%]*$/,
    ];

    const regex = new RegExp(regexTerms.map((r) => r.source).join("|"), "gi");
    return regex;
  }

  function getEquivalentTerms(term, paragraphs) {
    var t = [];

    t.push(term);

    return t;
  }

  function initAlternativeTerms(word, paragraphs) {
    var equivalentTerms = getEquivalentTerms(word, paragraphs);

    var t = [];

    for (var i = 0; i < equivalentTerms.length; i++) {
      const obj = {
        word: equivalentTerms[i],
        match: equivalentTerms[i],
        id: guidGenerator(),
      };

      t.push(obj);
    }

    return t;
  }

  function isInToC(term, paragraphs) {
    const equivalentTerms = getEquivalentTerms(term, paragraphs);

    equivalentTerms.push(term);

    return paragraphs
      .filter((r) => r.isToc)
      .filter((r) => equivalentTerms.indexOf(r.text.toUpperCase()) > -1)[0];
  }

  function checkToc(paragraphs) {
    //return paragraphs.filter((r) => r.isToc).length > 0;
    return false;
  }

  function getTerms(paragraphs) {
    const definedRegEx = getDefinedRegEx();
    const wordRegEx = getWordRegex();
    const titleRegex = getTitleRegex();

    let exhibits = [];

    paragraphs.forEach((paragraph, index) => {
      if (paragraph.text === "") {
        return;
      }

      if (!paragraph.isParagraph) {
        return;
      }

      const definedMatch = paragraph.text.match(wordRegEx);

      if (definedMatch !== null) {
        const word = definedMatch[0].match(wordRegEx);
        const title = paragraph.text.match(titleRegex);

        if (word == null) {
          return;
        }

        const inToc = isInToC(word[0], paragraphs);
        // if (checkToc(paragraphs) && !inToc) return; // Keep this commented out for now

        let tableDetected = false;
        let currentWord = word[0].replace("“", ""); // Ensure correct quotes
        currentWord = currentWord.replace("”", ""); // Ensure correct quotes
        currentWord = currentWord.replaceAll('"', "");
   
        const definitionParagraphs = [];
        const cleanParagraph = paragraph.text.trim();
        definitionParagraphs.push(paragraph);
      
        let paragraphEndFound = false;
        let count = 0;
        let nextParagraphIndex = index;
        let endOnNext = false;

        while (!paragraphEndFound && count < 50) {
          count += 1;
          nextParagraphIndex += 1;

          const nextP = paragraphs[nextParagraphIndex];


          if (endOnNext) {
            paragraphEndFound = true;
            continue;
          }

          if (!nextP) {
            paragraphEndFound = true;
            continue;
          }


          if (nextP.text === "") {
            continue;
          }

          if (nextP.tableNestingLevel > 0) {
            tableDetected = true;
            continue;
          }

          if (nextP.text.match(getDefinedRegEx())) {
            paragraphEndFound = true;
            continue;
          }

          if (nextP.text.match(getSigPageRegex())) {
            paragraphEndFound = true;
            continue;
          }

          if (nextP.text.match(getBreakSectionRegex())) {
            paragraphEndFound = true;
            continue;
          }

          // Note: The period check is currently disabled in the original code
          // if (nextP.text.slice(-1) === "." && nextP.isParagraph) {
          //    console.log(`DEBUG Loop ${count}: Found period at end (but currently ignored).`);
          // }

          // console.log(`DEBUG Loop ${count}: Adding paragraph to definition: [${nextP.text}]`);
          definitionParagraphs.push(nextP);
        }

        let i = exhibits.length;
        let found = false;

        while (i--) {
          const exhibit = exhibits[i];

          if (exhibit.word.toUpperCase() === currentWord.toUpperCase()) {
            for (var j = 0; j < definitionParagraphs.length; j++) {
              exhibit.definedDefinition.push(definitionParagraphs[j]);
            }
            found = true;
          }
        }

        if (!found) {
          exhibits.push({
            id: guidGenerator(),
            match: definedMatch,
            word: currentWord,
            definition: null,
            definedDefinition: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(paragraph.localName)
                               ? definitionParagraphs // Keep all if heading
                               : definitionParagraphs.slice(0, 2), // Keep mention + 1 if inline
            definedTableDetected: false,
            title: inToc ? (title ? title[0] : "") : currentWord,
            alternativeTerms: initAlternativeTerms(currentWord, paragraphs),
            type: "exhibit",
          });
        }
      }
    });

    return exhibits;
  }

  return {
    getExhibits: function (dom) {
      var ps = dom.querySelectorAll("p, tr, h1, h2, h3, h4, h5, h6");
      var paragraphs = [];

      var isToc = false;

      ps.forEach(function (item, idx) {
        if (
          isToc &&
          item.localName != "tr" &&
          (item.textContent.trim() ?? "").length > 5 &&
          item.textContent.trim().toLowerCase() != "section" &&
          item.textContent.trim().toLowerCase() != "table of contents" &&
          item.textContent.trim() != "Section" &&
          item.closest("table") === null
        ) {
          isToc = false;
        }

        if (item.textContent.trim().toLowerCase() === "table of contents") {
          isToc = true;
        }

        paragraphs.push({
          html: (item.outerHTML ?? "")
            .replaceAll("‚Äú", "“")
            .replaceAll("‚Äù", "”")
            .replaceAll("&nbsp;", " ")
            .replaceAll(/[\u202F\u00A0]/g, " ")
            .replaceAll(/\s\s+/g, " "),
          text: (item.textContent.trim() ?? "")
            .replaceAll("‚Äú", "“")
            .replaceAll("‚Äù", "”")
            .replaceAll("&nbsp;", " ")
            .replaceAll(/[\u202F\u00A0]/g, " ")
            .replaceAll(/\s\s+/g, " "),
          isParagraph:
            item.localName == "p" ||
            item.localName == "h1" ||
            item.localName == "h2" ||
            item.localName == "h3" ||
            item.localName == "h4" ||
            item.localName == "h5" ||
            item.localName == "h6",
          isToc: isToc,
          localName: item.localName,
        });
      });

      const exhibits = getTerms(paragraphs);
console.log(exhibits)
      return exhibits;
    },
  };
};

export default exhibitsFinder;
